/*
  Presscription theme script.

  The cart contract is one event. Anything that changes the cart dispatches
  theme:cartchanged on document.documentElement:

    document.documentElement.dispatchEvent(new CustomEvent('theme:cartchanged', {
      bubbles: true, detail: { openDrawer: true }
    }));

  This file redraws the cart drawer from the server, updates every cart count
  on the page, and opens the drawer when detail.openDrawer is true.
*/
(function () {
  'use strict';

  var ROOT = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  var Press = window.Press = window.Press || {};

  function jsonFetch(url, opts) {
    opts = opts || {};
    opts.credentials = 'same-origin';
    opts.headers = Object.assign({ 'Accept': 'application/json' }, opts.headers || {});
    return fetch(url, opts).then(function (r) {
      return r.json().then(function (data) {
        if (!r.ok) { var e = new Error(data.description || data.message || r.status); e.data = data; throw e; }
        return data;
      });
    });
  }
  Press.fetchJSON = jsonFetch;

  Press.cartChanged = function (openDrawer) {
    document.documentElement.dispatchEvent(new CustomEvent('theme:cartchanged', {
      bubbles: true, cancelable: false, detail: { openDrawer: !!openDrawer }
    }));
  };

  /* ---------------- cart counts ---------------- */
  function setCounts(count) {
    document.querySelectorAll('[data-cart-count], .cart-link__count').forEach(function (el) {
      el.textContent = count;
      el.hidden = count < 1;
      el.classList.toggle('is-empty', count < 1);
    });
    document.querySelectorAll('.cart-link').forEach(function (a) {
      a.setAttribute('aria-label', 'Basket, ' + count + (count === 1 ? ' item' : ' items'));
    });
  }

  /* ---------------- drawer ---------------- */
  var drawer = null;
  var lastFocus = null;

  function getDrawer() {
    drawer = document.querySelector('[data-cart-drawer]');
    return drawer;
  }

  function openDrawer() {
    if (!getDrawer()) return false;
    lastFocus = document.activeElement;
    drawer.hidden = false;
    requestAnimationFrame(function () {
      drawer.classList.add('is-open');
      drawer.setAttribute('aria-hidden', 'false');
    });
    document.body.classList.add('is-locked');
    var close = drawer.querySelector('[data-cart-close]');
    if (close) setTimeout(function () { close.focus(); }, 60);
    return true;
  }

  function closeDrawer() {
    if (!getDrawer()) return;
    drawer.classList.remove('is-open');
    drawer.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('is-locked');
    setTimeout(function () { if (!drawer.classList.contains('is-open')) drawer.hidden = true; }, 320);
    if (lastFocus && lastFocus.focus) lastFocus.focus();
  }
  Press.openCart = openDrawer;
  Press.closeCart = closeDrawer;

  var refreshing = null;
  function refreshDrawer() {
    if (!getDrawer()) return Promise.resolve();
    var id = drawer.getAttribute('data-section-id') || 'cart-drawer';
    if (refreshing) refreshing.abort && refreshing.abort();
    var ctrl = window.AbortController ? new AbortController() : null;
    refreshing = ctrl;
    return fetch(ROOT + '?sections=' + encodeURIComponent(id), { credentials: 'same-origin', signal: ctrl ? ctrl.signal : undefined })
      .then(function (r) { return r.json(); })
      .then(function (data) {
        var html = data && data[id];
        if (!html) return;
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var fresh = doc.querySelector('[data-cart-drawer-body]');
        var current = drawer.querySelector('[data-cart-drawer-body]');
        if (fresh && current) {
          var scroller = current.querySelector('[data-cart-scroll]');
          var top = scroller ? scroller.scrollTop : 0;
          current.replaceWith(fresh);
          var nextScroller = fresh.querySelector('[data-cart-scroll]');
          if (nextScroller) nextScroller.scrollTop = top;
        }
      })
      .catch(function () {});
  }
  Press.refreshCart = refreshDrawer;

  function refreshCounts() {
    return jsonFetch(ROOT + 'cart.js').then(function (cart) {
      setCounts(cart.item_count);
      Press.cart = cart;
      document.dispatchEvent(new CustomEvent('press:cart', { detail: { cart: cart } }));
      return cart;
    }).catch(function () {});
  }

  document.addEventListener('theme:cartchanged', function (e) {
    var wantOpen = e.detail && e.detail.openDrawer;
    var onCartPage = document.body.classList.contains('template-cart');
    refreshCounts();
    refreshDrawer().then(function () {
      if (wantOpen && !onCartPage) {
        if (!openDrawer()) window.location.href = ROOT + 'cart';
      }
    });
  });

  /* ---------------- drawer interactions ---------------- */
  function busy(on) {
    if (!getDrawer()) return;
    drawer.classList.toggle('is-busy', !!on);
  }

  function changeLine(line, quantity) {
    busy(true);
    return jsonFetch(ROOT + 'cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ line: line, quantity: quantity })
    }).catch(function (err) {
      var msg = drawer && drawer.querySelector('[data-cart-error]');
      if (msg) { msg.textContent = (err && err.message) || 'That could not be updated. Please try again.'; msg.hidden = false; }
    }).then(function () {
      busy(false);
      Press.cartChanged(false);
    });
  }

  document.addEventListener('click', function (e) {
    var t = e.target;
    if (!t.closest) return;

    var opener = t.closest('[data-cart-open], .cart-link');
    if (opener && getDrawer() && !document.body.classList.contains('template-cart')) {
      e.preventDefault();
      openDrawer();
      return;
    }

    if (t.closest('[data-cart-close]')) { e.preventDefault(); closeDrawer(); return; }

    var step = t.closest('[data-qty-step]');
    if (step && step.closest('[data-cart-drawer]')) {
      e.preventDefault();
      var row = step.closest('[data-line]');
      var input = row && row.querySelector('[data-qty-input]');
      var next = Math.max(0, parseInt(input ? input.value : '0', 10) + parseInt(step.getAttribute('data-qty-step'), 10));
      if (input) input.value = next;
      changeLine(parseInt(row.getAttribute('data-line'), 10), next);
      return;
    }

    var remove = t.closest('[data-line-remove]');
    if (remove && remove.closest('[data-cart-drawer]')) {
      e.preventDefault();
      var r = remove.closest('[data-line]');
      if (r) r.classList.add('is-removing');
      changeLine(parseInt(r.getAttribute('data-line'), 10), 0);
    }
  });

  document.addEventListener('change', function (e) {
    var input = e.target.closest && e.target.closest('[data-cart-drawer] [data-qty-input]');
    if (input) {
      var row = input.closest('[data-line]');
      changeLine(parseInt(row.getAttribute('data-line'), 10), Math.max(0, parseInt(input.value, 10) || 0));
      return;
    }
    var note = e.target.closest && e.target.closest('[data-cart-drawer] [data-cart-note]');
    if (note) {
      jsonFetch(ROOT + 'cart/update.js', {
        method: 'POST', headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ note: note.value })
      }).catch(function () {});
    }
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && drawer && drawer.classList.contains('is-open')) closeDrawer();
    if (e.key === 'Tab' && drawer && drawer.classList.contains('is-open')) {
      var f = drawer.querySelectorAll('a[href], button:not([disabled]), input:not([type="hidden"]), select, textarea, [tabindex]:not([tabindex="-1"])');
      f = Array.prototype.filter.call(f, function (el) { return el.offsetParent !== null; });
      if (!f.length) return;
      var first = f[0], last = f[f.length - 1];
      if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
    }
  });

  /* ---------------- product forms ---------------- */
  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form.matches || !form.matches('form[data-product-form]')) return;
    e.preventDefault();
    var btn = form.querySelector('[type="submit"]');
    var err = form.querySelector('[data-form-error]');
    if (err) { err.hidden = true; err.textContent = ''; }
    if (btn) { btn.setAttribute('aria-busy', 'true'); btn.disabled = true; }
    var body = new FormData(form);
    fetch(ROOT + 'cart/add.js', { method: 'POST', body: body, credentials: 'same-origin', headers: { 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' } })
      .then(function (r) { return r.json().then(function (d) { if (!r.ok) throw d; return d; }); })
      .then(function () {
        if (settingsCartType() === 'page') { window.location.href = ROOT + 'cart'; return; }
        Press.cartChanged(true);
      })
      .catch(function (d) {
        if (err) { err.textContent = (d && (d.description || d.message)) || 'Sorry, that could not be added. Please try again.'; err.hidden = false; }
      })
      .then(function () { if (btn) { btn.removeAttribute('aria-busy'); btn.disabled = false; } });
  });

  function settingsCartType() {
    return document.documentElement.getAttribute('data-cart-type') || (getDrawer() ? 'drawer' : 'page');
  }

  /* ---------------- variant pickers on the product template ---------------- */
  function initVariantPicker(root) {
    var dataEl = root.querySelector('[data-product-json]');
    if (!dataEl) return;
    var product;
    try { product = JSON.parse(dataEl.textContent); } catch (e) { return; }
    var idInput = root.querySelector('input[name="id"]');
    var pickers = root.querySelectorAll('[data-option-index]');
    function selected() {
      var opts = [];
      pickers.forEach(function (p) {
        var i = parseInt(p.getAttribute('data-option-index'), 10);
        if (p.tagName === 'SELECT') opts[i] = p.value;
        else if (p.checked) opts[i] = p.value;
      });
      return opts;
    }
    function update() {
      var opts = selected();
      var variant = product.variants.find(function (v) {
        return v.options.every(function (o, i) { return opts[i] === undefined || opts[i] === o; });
      });
      var btn = root.querySelector('[data-add-button]');
      var label = root.querySelector('[data-add-label]');
      if (!variant) {
        if (btn) btn.disabled = true;
        if (label) label.textContent = 'Unavailable';
        return;
      }
      if (idInput) idInput.value = variant.id;
      if (btn) btn.disabled = !variant.available;
      if (label) label.textContent = variant.available ? (label.getAttribute('data-label-add') || 'Add to basket') : (label.getAttribute('data-label-soldout') || 'Sold out');
      var price = root.querySelector('[data-price]');
      if (price && variant.price_html) price.innerHTML = variant.price_html;
      var url = new URL(window.location.href);
      url.searchParams.set('variant', variant.id);
      window.history.replaceState({}, '', url.toString());
      if (variant.featured_media_id) {
        var slide = root.querySelector('[data-media-id="' + variant.featured_media_id + '"]');
        if (slide && slide.scrollIntoView) slide.parentElement.scrollTo({ left: slide.offsetLeft, behavior: 'smooth' });
      }
      root.dispatchEvent(new CustomEvent('press:variant', { bubbles: true, detail: { variant: variant } }));
    }
    pickers.forEach(function (p) { p.addEventListener('change', update); });
  }

  function boot(scope) {
    (scope || document).querySelectorAll('[data-variant-root]').forEach(initVariantPicker);
  }

  document.addEventListener('DOMContentLoaded', function () {
    getDrawer();
    boot();
  });
  document.addEventListener('shopify:section:load', function (e) { boot(e.target); getDrawer(); });
})();
